export default {
  createPost: '/posts/upload',
  getPosts: '/posts/getAllPostsForAUser'
}
